<template>
  <paper-simple body-class="p-0">
    <div class="d-flex justify-content-between align-items-center p-2">
      <div class="d-flex flex-column">
        <div class="text-lg text-thick">
          {{ title }}
        </div>
        <p class="m-0 text-sm text-secondary">
          {{ description }}
        </p>
      </div>
      <b-form-checkbox
        v-model="enabled"
        name="use_wide-wine"
        class="mb-0"
        switch
      >
        <span>
          Use
        </span>
      </b-form-checkbox>
    </div>
    <transition name="fade">
      <div
        v-if="enabled"
        class="border-default border-t"
        :class="hasPadding? 'p-2' : ''"
      >
        <slot />
      </div>
    </transition>
  </paper-simple>

</template>

<script>
export default {
  name: 'DrmType',
  props: {
    title: {
      type: String,
      default: null,
      required: true,
    },
    description: {
      type: String,
      default: null,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    hasPadding: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      enabled: false,
    }
  },
  watch: {
    enabled() {
      this.$emit('input', this.enabled)
    },
  },
  created() {
    this.enabled = this.value
  },
  methods: {
    fetchDrm() {
      this.$store.dispatch('drm/getDrm').catch(err => {
        console.log(err)
      })
    },
  },
}
</script>

<style>
  .drm .custom-control.custom-switch label.custom-control-label{
    margin-bottom:0 !important;
  }
  .drm .custom-control.custom-switch label.custom-control-label span{
    margin-left:5px;
  }
</style>
